const drivers = {
  drivers: 'Motoristas',

  createNew: 'Novo',

  headerButtons: {
    create: {
      createBtn: 'Criar',
    },

    import: 'Importar',
  },

  import: {
    title: 'Importar Motoristas',
  },

  toast: {
    error: {
      badResponse: '[Driver] resposta inválida do servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
    },
  },
  table: {
    headers: {
      displayName: 'Nome',
      name: 'Nome',
      driverStatus: 'Status',
      email: 'E-mail',
      vehicle: 'Veículo',
      phoneNumber: 'Número de telefone',
      address: 'Endereço',
      firstTripDistance: 'Distância máxima da 1ª Viagem',
      action: 'Ação',
      attributes: 'Atributos',
      locations : 'Localizações',
      areas: 'Zonas',
      excludedProfiles: 'Perfis Excluídos',
    },
    statusOptions: {
      online: 'Online',
      offline: 'Off-line',
      break: 'Pausa',
      enRoute: 'Em rota',
      suspended: 'Suspensa',
    },
    viewOptions: {
      showSuspended: 'Mostrar suspenso',
      showUnsuspended: 'Mostrar Não suspenso',
    },
    filters: {
      status: 'Status',
      vehicles: 'Veículos',
      areas: 'Zonas',
      services: 'Serviços',
      suppliers: 'Fornecedores',
      attributes: 'Atributos',
      locations: 'Localizações',
      airportLocations: 'Localizações de Aeroporto',
    },
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  create: {
    submit: {
      success: 'O motorista foi criado com sucesso',
      error: 'Não foi possível criar motorista devido a um erro interno do servidor',
    },
  },

  update: {
    submit: {
      success: 'O motorista foi atualizado com sucesso',
      error: 'Não foi possível atualizar o motorista devido a um erro interno do servidor',
    },
    formTabs: {
      informationTab: 'Informação',
      notesTab: 'Observações',
      historyTab: 'Histórico',
      reservationPreferencesTab: 'Preferências de Reserva',
    },
    toast: {
      toastResetSuccess: 'O e-mail de Redefinição de Senha foi enviado com sucesso.',
      toastError: 'Ocorreu um erro, por favor, tente novamente.',
      toastRemoveDriverSuccess: 'Motorista excluído com sucesso',
    },
    driverStatusOptions: {
      activate: 'Reativar',
      deactivate: 'Suspender',
      statusActive: 'Ativo',
      statusInactive: 'Inativa',
      statusOffline: 'Off-line',
      statusOnline: 'Online',
      statusEnRoute: 'Em rota',
      statusBreak: 'Pausa',
      popUpOptions: {
        popupTitleActive: 'Suspender motorista',
        popupTitleDeactivation: 'Reativar Motorista',
        popupTitleUnsuspend: 'Motivo de Anular a Suspensão',
        popupSubTitleDeactivation: 'Selecione o motivo da suspensão',
        popupActionActive: 'Reativar Motorista',
        popupActionDeactivate: 'Suspender motorista',
      },
    },
    modalRemoveConfirm: {
      header: 'Aviso!',
      body: 'Você tem certeza de que deseja excluir este motorista?',
      confirmBtn: 'Remover',
    },
  },
  deleteModal: {
    header: 'Excluir Motoristas',
    body: 'Você está prestes a excluir {{num}} motoristas.',
    success: 'Os motoristas foram excluídos com sucesso',
  },

  forms: {
    header: {
      createDriver: {
        title: 'Criar',
      },

      updateDriver: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      personalDetails: {
        header: 'Detalhes pessoais',
        fields: {
          firstName: 'Nome',
          lastName: 'Sobrenome',
          name: 'Nome de exibição',
          phone: 'Número de telefone',
          email: 'Endereço de e-mail',
          password: 'Senha',
        },
      },
      areaSettings: {
        header: 'Configurações de zona',
        fields: {
          areas: 'Zonas',
          mode: 'Modo',
          priority: 'Prioridade',
          modeOptions: {
            allStops: 'Todas as Paradas',
            firstPickDrop: 'Primeiro Embarque / Última Entrega',
            legAOrigin: 'Origem do Trecho A',
          },
          priorityOptions: {
            low: 'Baixo',
            medium: 'Médio',
            high: 'Alto',
            strict: 'Rígido',
          },
        },
      },
      locationsSettings: {
        header: 'Configurações de Localizações',
        fields: {
          locations: 'Localizações',
          enableInBetweenRides: 'Ativar Corridas Intermediárias',
        },
      },
      vehicles: {
        header: 'Veículos Atribuídos',
        fields: {
          available: 'Veículos disponíveis',
          current: 'Veículo atual',
        },
      },
      address: {
        header: 'Endereço Inicial',
        fields: {
          mainAddress: 'Endereço principal',
          firstTripDistance: 'Distância máxima da 1ª Viagem',
          alt: 'Endereço Alternativo',
        },
      },
      settings: {
        header: 'Configurações adicionais',
        fields: {
          services: 'Serviços',
          areas: 'Zonas',
          externalId: 'Identificador Externo',
          ignoreDropoffTime: 'Ignore Drop-Off Time',
          ignoreDropoffTimeOptions: {
            bySystemSettings: 'Pelas configuracoes do sistema',
            enabled: 'Ativado',
            disabled: 'Desativado',
          },
          shiftBuffer: 'Shift Buffer',
        },
      },
      supplier: {
        header: 'Fornecedores',
        fields: {
          suppliers: 'Fornecedores',
        },
      },
      allowSharedRides: {
        header: 'Permitir viagens compartilhadas',
        fields: {
          allowSharedRides: 'Permitir viagens compartilhadas',
        },
      },
      attributes: {
        header: 'Atributos',
      },
      excludedProfiles: {
        header: 'Perfis Excluídos',
        dualList: {
          profilesList: {
            header: 'Lista de Perfis',
          },
          excludedList: {
            header: 'Perfis Excluídos',
          },
        },
      },
      buttons: {
        btnResetPassword: 'Redefinir Senha',
        btnDelete: 'Remover',
      },
    },
  },
};

export default drivers;
